module.exports = __webpack_public_path__ + "static/media/image-video-8.714c7682.png";